<template>
  <div class="h-100">
    <vue3-progress-bar></vue3-progress-bar>
    <div class="d-flex flex-column flex-root align-items-stretch h-100">
      <div class="page d-flex flex-row align-items-stretch flex-column-fluid">
        <div id="kt_aside" class="aside aside-light aside-hoverable" data-kt-drawer="true" data-kt-drawer-name="aside"
          data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
          data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
          data-kt-drawer-toggle="#kt_aside_mobile_toggle">
          <div class="aside-logo flex-column-auto" id="kt_aside_logo">
            <router-link :to="'/admin/dashboard'">
              <a href="" class="aside-logo-link">
                <img alt="Logo" src="/assets/media/logos/qomerxia-logo.png" class="h-25px logo"  />
                <img alt="Logo" src="/assets/media/logos/qomerxia-icon.png" class="h-30px logo-minimize" />
              </a>
            </router-link>
            <div id="kt_aside_toggle" class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
              data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body"
              data-kt-toggle-name="aside-minimize">
              <span class="svg-icon svg-icon-1 rotate-180">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.5"
                    d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
                    fill="currentColor" />
                  <path
                    d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
                    fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <app-menu></app-menu>
        </div>
        <div class="wrapper d-flex flex-column align-items-stretch flex-row-fluid" id="kt_wrapper">
          <app-header :numberNotification="notifications ? notifications.length : 0"></app-header>
          <!-- Notifications de commande pas encore autorisées sur cet appareil : l'autorisation
               doit suivre un appui (obligatoire sur iPhone, application installée) -->
          <div v-if="showPushPrompt" class="alert alert-primary d-flex align-items-center flex-wrap gap-3 mx-4 mt-4 mb-0 py-3">
            <i class="bi bi-bell fs-2 text-primary"></i>
            <span class="flex-grow-1 text-gray-800">{{ $t('push_prompt.text') }}</span>
            <button type="button" class="btn btn-sm btn-primary" @click="enablePush">{{ $t('push_prompt.enable') }}</button>
            <button type="button" class="btn btn-sm btn-light" @click="showPushPrompt = false">{{ $t('push_prompt.later') }}</button>
          </div>
          <!-- Essai gratuit en cours : jours restants et accès au choix de l'offre -->
          <div v-if="trial" class="alert alert-warning d-flex align-items-center flex-wrap gap-3 mx-4 mt-4 mb-0 py-3">
            <i class="bi bi-hourglass-split fs-2 text-warning"></i>
            <span class="flex-grow-1 text-gray-800">{{ $t('subscription.trial_banner', { days: trial.days_left }) }}</span>
            <router-link v-if="trial.can_pay" :to="{ name: 'subscription-plans' }" class="btn btn-sm btn-warning">{{ $t('subscription.choose_plan') }}</router-link>
          </div>
          <router-view></router-view>
          <app-footer></app-footer>
          <!-- Aide contextuelle (bouton « Aide » du menu et de l'en-tête) -->
          <help-drawer></help-drawer>
          <onboarding-modal></onboarding-modal>
        </div>
      </div>
    </div>
    <div id="kt_drawer_chat" class="bg-body" data-kt-drawer="true" data-kt-drawer-name="chat"
      data-kt-drawer-activate="true" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_drawer_chat_toggle"
      data-kt-drawer-close="#kt_drawer_chat_close">
      <div class="card w-100 rounded-0 border-0 m-2" id="kt_drawer_chat_messenger">
        <div class="card-header pe-5" id="kt_drawer_chat_messenger_header">
          <div class="card-title">
            <div class="d-flex justify-content-center flex-column me-3">
              <a class="nav-link active">Notifications ({{ notifications ? notifications.length : 0 }})</a>
            </div>
          </div>
          <div class="card-toolbar">
            <div class="btn btn-sm btn-icon btn-active-light-primary" id="kt_drawer_chat_close">
              <span class="svg-icon svg-icon-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                    fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                    fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div class="tab-header d-flex justify-content-center my-5 gap-3">
          <button
              v-for="tab in visibleTabs"
              :key="tab"
              class="btn position-relative"
              :class="{ 'btn-primary': selectedTab === tab, 'btn-light': selectedTab !== tab }"
              @click="selectedTab = tab"
          >
            {{ $t(`alert.tab_${tab}s`) }}
            ({{ tabCount(tab) }})
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"></span>
          </button>

        </div>


        <div class="tab-content">
          <div class="scroll-y mh-420px my-5 px-8">
            <div v-if="selectedTab === 'alert'">
              <div v-if="!alertNotifications.length" class="d-flex flex-stack py-4">
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-35px me-4">
                  <span class="symbol-label bg-light-danger">
                    <span class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                              fill="currentColor" />
                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                              fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div class="text-gray-400 fs-7">{{ $t('alert.not_notification') }}</div>
                  </div>
                </div>
              </div>
              <div v-else v-for="(stock_alert, key) in alertNotifications" :key="key" class="d-flex flex-stack py-4">
                <div class="d-flex align-items-center flex-grow-1">
                  <div class="symbol symbol-35px me-4">
                  <span class="symbol-label">
                    <span v-if="stock_alert?.type == 'alert'" class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                              fill="currentColor" />
                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                              fill="currentColor" />
                      </svg>
                    </span>
                    <span v-else-if="stock_alert?.type == 'transfert'" class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-shield-exclamation" viewBox="0 0 16 16">
                        <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                        <path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/>
                      </svg>
                    </span>
                    <span v-else class="svg-icon svg-icon-2 svg-icon-warning">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </span>
                  </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div v-if="stock_alert?.type != 'transfert'" class="text-gray-900 fs-7">
                      {{ formateText(stock_alert.productName, stock_alert.shopName, stock_alert.type, ) }} <br>
                      <strong>{{ $t('alert.qtite_actuel') }}: {{ stock_alert.stock }}</strong>
                    </div>
                    <div v-else class="text-gray-900 fs-7">
                      {{ formateText(stock_alert.productName, stock_alert.shopName, stock_alert.type, ) }} <br>
                      <strong>{{ $t('store.entrie.quantity') }}: {{ stock_alert.quantity_sent }}</strong> | <strong>{{ $t('shop.received_quantity') }}: {{ stock_alert.quantity_receive }}</strong><br>
                      <strong v-if="stock_alert.comments">{{ $t('store.ask.comment') }}:</strong> {{ stock_alert.comments }}
                    </div>
                  </div>
                </div>
                <button class="btn btn-sm btn-icon btn-light-danger" @click="dismissNotification(stock_alert, key)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div v-if="selectedTab === 'expiration'">
              <div v-if="!expirationNotifications.length" class="d-flex flex-stack py-4">
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-35px me-4">
                  <span class="symbol-label bg-light-danger">
                    <span class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                              fill="currentColor" />
                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                              fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div class="text-gray-400 fs-7">{{ $t('alert.not_notification') }}</div>
                  </div>
                </div>
              </div>
              <div v-else v-for="(stock_alert, key) in expirationNotifications" :key="key" class="d-flex flex-stack py-4 border-bottom">
                <div class="d-flex align-items-center flex-grow-1">
                  <div class="symbol symbol-35px me-4">
                  <span class="symbol-label">
                    <span v-if="stock_alert?.type == 'alert'" class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                        <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)"
                              fill="currentColor" />
                        <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)"
                              fill="currentColor" />
                      </svg>
                    </span>
                    <span v-else-if="stock_alert?.type == 'transfert'" class="svg-icon svg-icon-2 svg-icon-danger">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-shield-exclamation" viewBox="0 0 16 16">
                        <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                        <path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/>
                      </svg>
                    </span>
                    <span v-else class="svg-icon svg-icon-2 svg-icon-warning">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </span>
                  </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div class="text-gray-900 fs-7 mb-1">
                      {{ formateText(stock_alert.productName, stock_alert.shopName, stock_alert.type, stock_alert.stock, stock_alert.remaining_days) }}
                      <span class="text-danger">
          {{ stock_alert.remaining_days }} {{ $t('alert.days') }}
        </span>
                      <br />
                      <strong>{{ $t('alert.qtite_actuel') }}: {{ stock_alert.stock }}</strong>
                    </div>
                    <div class="mt-1">
                      <i><span class="text-gray-900" v-if="stock_alert.remaining_days <= 10">
          Ce produit expire bientot. Mettez-le en promotion pour limiter les pertes.
        </span></i>
                      <button
                          class="btn btn-sm btn-light-primary mt-2"
                          @click="goToPromotionPage(stock_alert)"
                      >
                        Mettre en promotion
                      </button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-sm btn-icon btn-light-danger ms-2" @click="dismissNotification(stock_alert, key)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
            <div v-if="selectedTab === 'order' && $can('order_view')">
              <div v-if="!orderNotifications.length" class="d-flex flex-stack py-4">
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-35px me-4">
        <span class="symbol-label bg-light-danger">
          <span class="svg-icon svg-icon-2 svg-icon-danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
              <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
              <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor" />
              <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor" />
            </svg>
          </span>
        </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div class="text-gray-400 fs-7">{{ $t('order.not_notification') }}</div>
                  </div>
                </div>
              </div>

              <div v-else v-for="(order, key) in orderNotifications" :key="key" class="d-flex flex-stack py-4 border-bottom">
                <div class="d-flex align-items-center flex-grow-1">
                  <div class="symbol symbol-35px me-4">
        <span class="symbol-label">
          <span class="svg-icon svg-icon-2 svg-icon-primary">
            <i class="bi bi-cart-check-fill fs-3 text-primary"></i>
          </span>
        </span>
                  </div>
                  <div class="mb-0 me-2">
                    <div class="text-gray-900 fs-7 mb-1">
                      Nouvelle commande <strong>#{{ order.number }}</strong><br>
                      Client : <strong>{{ order.customer }}</strong><br>
                      Montant : <strong>{{ orderAmount(order) }}</strong><br>
                      Date : <strong>{{ orderDateTime(order.created_at) }}</strong>
                    </div>

                    <div class="mt-1">
                      <button
                          class="btn btn-sm btn-light-primary mt-2"
                          @click="goToOrderPage(order)"
                      >
                        Voir la commande
                      </button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-sm btn-icon btn-light-danger ms-2" @click="dismissNotification(order, key)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { registerPush, pushPermissionNeeded } from '@/services/registerPush'
import AppFooter from './partials/AppFooter.vue'
import HelpDrawer from '@/components/help/HelpDrawer.vue'
import OnboardingModal from '@/components/onboarding/OnboardingModal.vue'
import AppHeader from './partials/AppHeader.vue'
import AppMenu from './partials/AppMenu.vue'
import { mapGetters, mapActions } from "vuex";
import introJs from 'intro.js';
import 'intro.js/introjs.css';
import { applyBranding } from '@/composables/useBranding'
import { playNewOrderSound } from '@/services/notificationSound'
import { buildOnboardingOptions } from '@/composables/useOnboardingTour'

export default {
  watch: {
    // l'onglet affiché disparaît (plus d'expiration, droit retiré) : on passe au premier disponible
    visibleTabs: {
      handler(tabs) {
        if (!tabs.includes(this.selectedTab)) this.selectedTab = tabs[0] || null;
      },
      deep: true,
    },

    // boutique active connue après le chargement de l'utilisateur, ou changée
    currentUser() {
      this.listenShopNotifications()
    },
    '$store.state.user.currentShop'() {
      this.listenShopNotifications()
    },
    '$route'() {
      this.productNotification()
      if (this.$can('order_view')) this.orderNotification()
    }
  },
  data() {
    return {
      notifications: [],
      // bandeau « Activer les notifications » (appareil pas encore autorisé)
      showPushPrompt: false,
      // abonnement d'essai gratuit en cours (bandeau), null sinon
      trial: null,
      selectedTab: null,
      _notifPollInterval: null,
      // commandes déjà connues : le son ne joue que pour les nouvelles (pas au premier chargement)
      knownOrderIds: null,
      notificationChannel: null,

      template_alert: i18n.global.t('alert.stock_alert'),
      template_security: i18n.global.t('alert.stock_security'),
      template_transfert: i18n.global.t('alert.transfert'),
      template_expiration: i18n.global.t('alert.expiration_message'),
      user: { id: null, lastname: null, firstname: null,email: null }
    }
  },

  components: {
    AppFooter, AppHeader, AppMenu, HelpDrawer, OnboardingModal
  },

  computed: {
    ...mapGetters('user', [
      'currentUser'
    ]),
    ...mapGetters('permission', [
      'permissions'
    ]),
    alertNotifications() {
      return this.notifications.filter(n => n.type === 'alert' || n.type === 'transfert'|| n.type === 'security');
    },
    expirationNotifications() {
      return this.notifications.filter(n => n.type === 'expiration');
    },

    orderNotifications() {
      return this.notifications.filter(n => n.type === 'orders');
    },

    visibleTabs() {
      return ['order', 'expiration', 'alert'].filter(tab => {
        if (tab === 'order') return this.$can('order_view');
        // onglet des expirations : seulement s'il y a quelque chose à y voir
        if (tab === 'expiration') return this.expirationNotifications.length > 0;
        return true;
      });
    }
  },

  updated() {
    this.$nextTick(() => {
      KTMenu.init();
      KTDrawer.init();
      KTToggle.init();
      KTScroll.init();
      const scrollEl = document.getElementById('kt_aside_menu_wrapper');
      const scrollInstance = scrollEl && KTScroll.getInstance(scrollEl);
      if (scrollInstance) scrollInstance.update();
    })
  },

  async mounted() {
    try { await this.loadPermissions() } catch (e) { console.error('loadPermissions failed', e) }
    try { await this.loadModules() } catch (e) { console.error('loadModules failed', e) }
    try { await this.initUserDetail() } catch (e) { console.error('initUserDetail failed', e) }
    // abonnement de cet appareil aux notifications de commande (une fois connecté)
    registerPush().catch((e) => console.warn('registerPush failed', e))
    this.loadTrial()
    this.showPushPrompt = pushPermissionNeeded()
    // Désactivé (2026-09-17) : le backoffice partagé doit rester identique pour
    // tous les clients (support/doc/screenshots cohérents) — la personnalisation
    // reste réservée à la boutique en ligne. À réactiver seulement si un jour
    // proposé comme argument premium de l'offre "instance dédiée".
    // VUE_APP_BACKOFFICE_BRANDING=true : les couleurs de la personnalisation de la boutique
    // (Landlord) s'appliquent au back-office. Sinon, ou pour ce que la boutique ne définit
    // pas, ce sont les couleurs par défaut de la plateforme (Landlord → Intégrations).
    if (process.env.VUE_APP_BACKOFFICE_BRANDING === 'true') this.loadBranding()
    else applyBranding({})
    this.productNotification()
    if (this.$can('order_view')) this.orderNotification()
    this.selectedTab = this.visibleTabs[0] || null

    const introJsOptions = buildOnboardingOptions()
    var introHasBeenShown = localStorage.getItem('introHasBeenShown');
    const voirGuideBtn = document.querySelector("#voir-guide");
    if (voirGuideBtn) {
      voirGuideBtn.addEventListener("click", function () {
        const intro = introJs();
        intro.setOptions(introJsOptions);
        intro.start();
      });
    }

    if (introHasBeenShown !== 'false') {
      const intro = introJs();
      intro.setOptions(introJsOptions)
      intro.start();
      localStorage.setItem('introHasBeenShown', 'false');
    }
    KTApp.init()

    const asideToggleEl = document.getElementById('kt_aside_toggle')
    if (asideToggleEl) {
      asideToggleEl.addEventListener('click', () => {
        localStorage.setItem('kt_aside_minimize', document.body.hasAttribute('data-kt-aside-minimize') ? 'on' : 'off')
      })
    }

    // Secours si le temps réel est indisponible
    this._notifPollInterval = setInterval(() => {
      if (this.$can('order_view')) this.orderNotification()
    }, 30000)

    this.listenShopNotifications()

  },

  unmounted() {
    if (this._notifPollInterval) {
      clearInterval(this._notifPollInterval)
    }
    this.stopListeningShopNotifications()
  },

  methods: {
    async loadTrial() {
      try {
        const { data } = await window.axios.get('subscription/current')
        this.trial = data.is_trial && !data.expired ? data : null
      } catch (e) {
        this.trial = null
      }
    },
    // Appui sur « Activer » : c'est ici que le navigateur peut demander l'autorisation
    async enablePush() {
      try {
        await registerPush({ prompt: true })
      } catch (e) {
        console.warn('registerPush failed', e)
      }
      this.showPushPrompt = pushPermissionNeeded()
    },

    // Temps réel : nouvelle commande sur la boutique active → liste rechargée
    // aussitôt (et son joué par orderNotification pour les commandes nouvelles).
    listenShopNotifications() {
      const shopId = this.$store.getters['user/currentShop']?.id ?? this.currentUser?.shop_id
      const channel = shopId ? `shop.${shopId}.notifications` : null
      if (!window.Echo || channel === this.notificationChannel) return
      this.stopListeningShopNotifications()
      if (!channel) return
      this.notificationChannel = channel
      window.Echo.private(channel).listen('.NewNotification', (event) => {
        if (event?.notification?.type === 'new-order' && this.$can('order_view')) {
          this.orderNotification()
        }
      })
    },

    stopListeningShopNotifications() {
      if (window.Echo && this.notificationChannel) {
        window.Echo.leave(this.notificationChannel)
      }
      this.notificationChannel = null
    },

    ...mapActions('user', [
      'getCurrentUser'
    ]),
    ...mapActions('permission', [
      'loadPermissions'
    ]),
    ...mapActions('tenantModule', [
      'loadModules'
    ]),
    ...mapActions('shop', [
      'productAlertNotification',
      'ecommerceOrderNotification'
    ]),

    tabCount(tab) {
      if (tab === 'alert') return this.alertNotifications.length;
      if (tab === 'expiration') return this.expirationNotifications.length;
      return this.orderNotifications.length;
    },

    dismissNotification(notification) {
      const notificationKey = this.getNotificationKey(notification);

      // Sauvegarder dans localStorage
      const dismissed = JSON.parse(localStorage.getItem('dismissedNotifications') || '[]');
      if (!dismissed.includes(notificationKey)) {
        dismissed.push(notificationKey);
        localStorage.setItem('dismissedNotifications', JSON.stringify(dismissed));
      }

      // Retirer de la liste (toutes les lignes de cette alerte) : les compteurs suivent
      this.notifications = this.notifications.filter(n => this.getNotificationKey(n) !== notificationKey);
    },

    // Identifiant d'une notification : celui donné par le serveur (une alerte par article et par
    // boutique) ; à défaut l'ancien, par nom de produit, qui confondait deux alertes de même nom
    getNotificationKey(notification) {
      if (notification.type === 'orders') {
        return `order_${notification.order_id}`;
      }
      return notification.key || this.legacyNotificationKey(notification);
    },

    legacyNotificationKey(notification) {
      return `${notification.type}_${notification.productName}_${notification.shopName}`;
    },

    filterDismissedNotifications(notifications) {
      const dismissed = JSON.parse(localStorage.getItem('dismissedNotifications') || '[]');
      // l'ancien identifiant reste reconnu : ce qui a déjà été fermé ne revient pas
      return notifications.filter(n => !dismissed.includes(this.getNotificationKey(n))
        && (n.type === 'orders' || !dismissed.includes(this.legacyNotificationKey(n))));
    },

    goToPromotionPage(product) {
      const shopId = product.shop_id || product.shopId;
      if (shopId) {
        this.closeNotificationPanel()
        this.$router.push({ name: 'shop-promotions', params: { id: shopId } });
      } else {
        console.warn("Impossible de trouver l'ID de la boutique pour ce produit.");
      }
    },

    goToOrderPage(order) {
      this.closeNotificationPanel()
      this.$router.push(`/admin/ecommerce/orders/${order.order_id}/view/destockage`)
    },
    // Panneau des notifications refermé quand on suit un lien : il restait ouvert par-dessus la page
    closeNotificationPanel() {
      const panel = document.getElementById('kt_drawer_chat')
      const drawer = panel && window.KTDrawer ? window.KTDrawer.getInstance(panel) : null
      if (drawer) drawer.hide()
    },
    getDaysUntilExpiration(expirationDate) {
      const today = new Date()
      const expiry = new Date(expirationDate)
      const diffTime = expiry - today
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },
    async productNotification() {
      try {
        let response = await this.productAlertNotification()
        let data = Object.values(response.data.alerts)
        const filteredData = this.filterDismissedNotifications(data)
        this.notifications = [
          ...this.notifications.filter(n => n.type === 'orders'),
          ...filteredData
        ]
      } catch (e) {
        console.error('productNotification failed', e)
      }
    },

    // « 27 271 xof » : montant arrondi, sans décimales
    orderAmount(order) {
      const amount = Math.round(parseFloat(order.total) || 0)
      return `${amount.toLocaleString('fr-FR')} ${order.currency || ''}`.trim()
    },
    // « 01/10/2026 à 14:32 » (heure locale)
    orderDateTime(value) {
      const date = new Date(value)
      if (isNaN(date)) return ''
      return `${date.toLocaleDateString('fr-FR')} à ${date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`
    },
    async orderNotification() {
      try {
        let response = await this.ecommerceOrderNotification()
        let data = response.data.orders.map(order => ({
          ...order,
          type: 'orders'
        }))
        const ids = data.map(order => order.order_id)
        if (this.knownOrderIds && ids.some(id => !this.knownOrderIds.has(id))) {
          playNewOrderSound()
        }
        this.knownOrderIds = new Set([...(this.knownOrderIds ?? []), ...ids])
        const filteredData = this.filterDismissedNotifications(data)
        this.notifications = [
          ...this.notifications.filter(n => n.type !== 'orders'),
          ...filteredData
        ]
      } catch (e) {
        console.error('orderNotification failed', e)
      }
    },


    async loadBranding() {
      try {
        // Le modèle Shop n'expose pas les couleurs (elles vivent sur SocietyInfo) —
        // il faut toujours passer par cet appel pour les récupérer correctement.
        const res = await this.$store.dispatch('core/getSocietyInfo', {})
        // boutique sans fiche : couleurs par défaut de la plateforme
        applyBranding(res.data?.societyInfo || {})
      } catch (e) { /* silent */ }
    },

    async initUserDetail(){
      let response = await this.getCurrentUser()

      this.user = {
        id: response.data.user.id,
        lastname: response.data.user.lastname,
        firstname: response.data.user.firstname,
        email: response.data.user.email,
      }
    },

    formateText(product_name, shop_name, type, stock, remaining_days = null) {
      let template = '';

      if (type === 'alert') {
        template = this.template_alert;
      } else if (type === 'transfert') {
        template = this.template_transfert;
      } else if (type === 'expiration') {
        template = this.template_expiration; // 👈 nouveau template pour expiration
      } else {
        template = this.template_security;
      }

      template = template.replace('[[ product_name ]]', product_name);
      template = template.replace('[[ shop_name ]]', shop_name);

      // si expiration, remplace aussi les jours restants
      if (type === 'expiration' && remaining_days !== null) {
        template = template.replace('[[ remaining_days ]]', remaining_days);
      }

      return template;
    }

  }
}
</script>
<style >

.page-loader {
  background: white;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: none;
}

.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Pages en container-xxl (largeur limitée à 1320px) : toute la largeur comme les pages en
   container-fluid, sinon une bande vide apparaît sur les côtés des grands écrans */
#kt_wrapper .container-xxl {
  max-width: none;
}</style>
statistique